import React from 'react';

export default class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    const message = String(error?.message || error || '');
    const isChunkError =
      /Loading chunk [\w-]+ failed/i.test(message) ||
      /ChunkLoadError/i.test(message) ||
      /Failed to fetch dynamically imported module/i.test(message);

    if (!isChunkError) return;

    try {
      if (typeof window === 'undefined') return;
      const key = 'dv_chunk_reload_once';
      const already = window.sessionStorage.getItem(key);

      if (!already) {
        window.sessionStorage.setItem(key, '1');
        window.location.reload();
      }
    } catch (e) {
      // Ignore and fall back to rendering the error UI.
    }
  }

  render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div className="flex flex-col items-center justify-center py-20 text-center">
          <div className="text-lg font-black text-slate-900 dark:text-white">
            Une mise à jour est disponible
          </div>
          <div className="text-sm text-slate-600 dark:text-slate-400 mt-2 max-w-md">
            La page a été mise à jour pendant votre navigation. Rechargez pour récupérer la dernière version.
          </div>
          <button
            onClick={() => window.location.reload()}
            className="mt-6 bg-blue-600 text-white px-6 py-3 rounded-xl font-black hover:bg-blue-700"
          >
            Recharger la page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
